<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			v-for="path in paths"
			:key="path"
			:d="path"
			:stroke="color"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconArrowsSwap',
	props: {
		size: {
			type: [Number, String],
			default: 16
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.33333
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		paths() {
			return [
				'M5.33317 2L2.6665 4.66667L5.33317 7.33333',
				'M2.6665 4.66675H13.3332',
				'M10.6665 14.0001L13.3332 11.3334L10.6665 8.66675',
				'M13.3332 11.3333H2.6665'
			]
		}
	}
}
</script>
